export const environment = {
  allowTestCreditCardNumbersUse: true,
  mode: 'uat',
  build: '339',
  production: false,
  enableServiceWorker: true,
  apiURL: 'https://devapi.uwsecure.uwatwork.com/api',
  //donorSiteUrl: 'https://secure2.uwatwork.com', //UAT API server base url
  donorSiteUrl: 'https://dev.uwsecure.uwatwork.com', //UAT API server base url
  apiconfig: {
    getTimeout: 60000,
    postTimeout: 60000,
    extendedTimeout: 780000 // 13 mins for long-running operations
  },
  ngIdleConfig: {
    keepaliveInterval: 600, // 10min will ping at this interval while not idle
    inactivityTimeoutMinutes: 30, // total inactivity before auto logout
    warningSeconds: 120, // warning countdown, counted within the total above
  },
  fileDownloadBaseUrl: 'https://devapi.uwsecure.uwatwork.com/Uploads',
};
